<header>
  <div class="w-full h-[62px] header-section bg-[#FFF]">
    <div class="text-[#010B18] font-bold text-xl font-open-sans">
      <span>Vault</span>
    </div>
    <div><mat-icon class="h-[24px] w-[24px] text-[#313131] flex-center cursor-pointer" (click)="close()">close</mat-icon></div>
  </div>
</header>

<section>
  <form>
    <div class="p-[24px]">
      <mat-form-field class="w-full">
        <div matPrefix class="search-input-icon ml-4 mt-[-1px] pr-2"><img src="../../../../assets/images/search-blue.svg" width="20px" height="19px" /></div>
        <!-- <mat-icon matPrefix class="search-input-icon" style="color: #5475C0;">search</mat-icon> -->
        @if(myControl.value) {
          <mat-icon matSuffix class="search-input-icon text-xl " style="color: #898F9E;" (click)="myControl.reset()">close</mat-icon>
        }
        <input type="text" placeholder="Search Vaults" aria-label="Number" matInput [formControl]="myControl" [matAutocomplete]="auto" />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="getDicoveryVaultName" class="mx-connect-modal-autocomplete">
          @if ((filteredVaults$ | async)?.length === 0) {
            <mat-option disabled> No results found </mat-option>
          }
          @for (item of filteredVaults$ | async; track item) {
            <mat-option [value]="item" style="padding: 12px 24px;">
              <div class="flex gap-[8px]" style="align-items: center;">
                <div class="bg-[#EBF0FA] h-[40px] w-[40px] rounded flex-center">
                  @if (!item?.type) {
                    <img class="avatar-grup h-[32px] w-[32px]" src="assets/images/vault/personal.svg" />
                  }
                  @if (item?.type === 'personal') {
                    <img class="avatar-grup h-[32px] w-[32px]" src="assets/images/vault/personal.svg" />
                  }
                  @if (item?.type === 'shared') {
                    <img class="avatar-grup h-[32px] w-[32px]" src="assets/images/vault/shared.svg" />
                  }
                  @if (item?.type === ('holding' || 'trust')) {
                    <img class="avatar-grup h-[32px] w-[32px]"
                      src="assets/images/vault/entity.svg" />
                  }
                </div>
                <div class="flex fl-col gap-[2px]">
                  <div class="text-[#18191C] font-semibold text-xs">{{ handleVaultNameForMultipleNames(item?.name) | truncateStrPipe : 26 }}</div>
                  <div class="text-[#707070] font-medium leading-3 text-[10px]">{{item.type | titlecase}}</div>
                </div>
              </div>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </form>
</section>

<footer>
  <div class="w-full px-[24px] py-[12px] footer-section">
    <button
      (click)="create()"
      class="cy-add-new-discovery-super-path-group craete-discovery-superPath-btn"
      [ngClass]="{ 'bg-blue': myControl.value, 'bg-gray': !myControl.value }"
      [disabled]="!myControl.value"
    >
      <span>Save</span>
    </button>
  </div>
</footer>
